import request from '@/utils/request'

export const menuApi = {
  // 获取菜单列表
  getMenus(params) {
    return request({
      url: '/menus/',
      method: 'get',
      params
    })
  },

  // 获取菜单树结构
  getMenuTree() {
    return request({
      url: '/menus/tree/',
      method: 'get'
    })
  },

  // 创建菜单
  createMenu(data) {
    return request({
      url: '/menus/',
      method: 'post',
      data
    })
  },

  // 更新菜单
  updateMenu(id, data) {
    // 处理parent字段
    const updateData = { ...data }
    if (updateData.parent === null || updateData.parent === '') {
      updateData.parent = null
    }
    
    return request({
      url: `/menus/${id}/`,
      method: 'put',
      data: updateData
    })
  },

  // 删除菜单
  deleteMenu(id) {
    return request({
      url: `/menus/${id}/`,
      method: 'delete'
    })
  },

  // 上传横幅图片
  uploadBanner(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request({
      url: '/menus/upload/',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    })
  }
} 